/** @format */

import axios from 'axios';

import Notify from '../../../../../../components/Commons/Notify';

import { ENV_TRANSACTION } from '../../../../../../components/Commons/Hooks/Variables/Enviroment';

export default async function resendEmailOrderService(item) {
	let returnResponse;
	await axios({
		method: 'POST',
		url: `${ENV_TRANSACTION}/emails/resend`,
		data: {
			trx_id: item,
		},
	})
		.then((response) => {
			if (response.data.statusCode === 200) {
				Notify({
					title: `¡Correo Enviado!`,
					colorTitle: 'ph-main-notification-success-title',
					description: `Revise su bandeja de Correo: ${response.data.data.data.info.email}`,
					time: 3,
					image: 'warning',
					placement: 'topRight',
				});
			} else {
				Notify({
					title: `¡Advertencia!`,
					colorTitle: 'ph-main-notification-warning-title',
					description: `Ha ocurrido un error. Contacte con Soporte`,
					time: 3,
					image: 'error',
					placement: 'topRight',
				});
			}
		})
		.catch((error) => {
			console.log(error);
			// Notify({
			// 	title: 'Problemas de Conexión',
			// 	colorTitle: 'ph-main-notification-error-title',
			// 	description: 'Revisa tu conexión o ponte en contacto con nosotros',
			// 	time: 4,
			// 	image: 'error',
			// 	placement: 'topRight',
			// });
		});

	return returnResponse;
}
